/**
 * All screen types
 */
export enum ScreenTypeEnum {
  TICKET = 'TICKET',
  CALL = 'CALL',
  CLIENT = 'CLIENT',
  TICKETLIST = 'TICKETLIST',
  INTERACTION = 'INTERACTION',
  CUSTOMERSEARCH = 'CUSTOMERSEARCH',
  CLIENTLIST = 'CLIENTLIST',
  INTERACTIONLIST = 'INTERACTIONLIST',
}

/**
 * Field screen relation interface
 */
export interface FieldScreenRelation {
  id: number
  entityField?: string
  customField?: string
  updatable: boolean
  mandatory: boolean
  alwaysVisible: boolean
  inPasteArea: boolean
  displayOrder: number
  defaultSortDir?: 'asc' | 'desc'
}

// V1
/**
 * Screen base interface
 */
export interface ScreenBaseDTOV1 {
  id: number
  code: UUID
  name: string
  type: ScreenTypeEnum
}
/**
 * Screen interface
 */
export interface ScreenDTOV1 extends ScreenBaseDTOV1 {
  fieldScreenRelations: FieldScreenRelation[]
}

export interface ListScreensParamsV1 {
  types?: ScreenTypeEnum[]
  creation?: boolean
  userIdToFilterBySkills?: number
}

// V2
export interface ScreenBaseDTOV2 {
  code: UUID
  type: ScreenTypeEnum
  active: boolean
  default: boolean
}

export interface ScreenDTOV2 extends ScreenBaseDTOV2 {
  descriptionDisplayComponents: ScreenDescriptionDisplayComponent[]
  descriptionDisplayModes: ScreenDescriptionDisplayMode[]
  evaluateDisplayRulesOnReadOnlyMode: boolean
  resetHiddenFields: boolean
  fields: ScreenField[]
}

export enum ScreenDescriptionDisplayComponent {
  CONTACT_DRIVER = 'CONTACT_DRIVER',
  PRODUCT = 'PRODUCT',
}

export enum ScreenDescriptionDisplayMode {
  INLINE = 'INLINE',
  TOOLTIP = 'TOOLTIP',
}

export interface ScreenField {
  displayOrder: number
  code: string
  sortDirection?: ScreenFieldSort
  alwaysVisible: boolean
  displayColumn?: 0 | 1 | 2
  editable?: boolean
  required?: boolean
}

export enum ScreenFieldSort {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

// V3
export interface ScreenBaseDTOV3 extends ScreenBaseDTOV2 {
  spaceCode?: UUID
  creation: boolean
}

export type FieldConditionDTOV1 = {
  sourceFieldCode: string
  sourceValues: string[]
  targetFieldCode: string
}

export type FieldConditionListDTOV1 = Array<FieldConditionDTOV1>
export type FieldConditionCollection = Map<string, FieldConditionDTOV1>
